const IconTel = ({ style }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      style={style}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.60568 8.3978C10.9649 11.7561 11.727 7.87092 13.8658 10.0083C15.9278 12.0697 17.1129 12.4827 14.5004 15.0945C14.1732 15.3575 12.094 18.5215 4.78703 11.2166C-2.52082 3.91074 0.641335 1.82943 0.904396 1.50227C3.52326 -1.11676 3.92915 0.0752698 5.99115 2.1367C8.12999 4.27494 4.24645 5.03951 7.60568 8.3978Z"
        fill="#E13B30"
      />
    </svg>
  );
};

export default IconTel;
